import { ReduxAction } from '../actions';
import { ActionTypes } from './actions';
import {
  WidgetIntegrationsState,
  INITIAL_STATE,
  BlockWidgetIntegrationsByBlockIdState,
} from './state';

const newBlockWidgetIntegrationStateByBlockId = (
  currentState: WidgetIntegrationsState,
  blockId: string,
  mergedData: Partial<BlockWidgetIntegrationsByBlockIdState>
): WidgetIntegrationsState => {
  return {
    ...currentState,
    blockWidgetIntegrations: {
      ...currentState.blockWidgetIntegrations,
      [blockId]: {
        ...currentState.blockWidgetIntegrations[blockId],
        ...mergedData,
      },
    },
  };
};

export function WidgetIntegrations(
  state: WidgetIntegrationsState = INITIAL_STATE,
  action: ReduxAction
): WidgetIntegrationsState {
  switch (action.type) {
    case ActionTypes.GET_BLOCK_WIDGET_INTEGRATIONS_START: {
      const { blockId } = action;
      return newBlockWidgetIntegrationStateByBlockId(state, blockId, {
        getBlockWidgetIntegrationsAsyncState: 'loading',
      });
    }
    case ActionTypes.GET_BLOCK_WIDGET_INTEGRATIONS_SUCCESS: {
      const { integrations, blockId } = action;
      return newBlockWidgetIntegrationStateByBlockId(state, blockId, {
        data: integrations,
        getBlockWidgetIntegrationsAsyncState: 'success',
      });
    }
    case ActionTypes.GET_BLOCK_WIDGET_INTEGRATIONS_FAILED: {
      const { blockId, error } = action;
      return newBlockWidgetIntegrationStateByBlockId(state, blockId, {
        getBlockWidgetIntegrationsAsyncState: 'failed',
        errorGetBlockWidgetIntegrations: error,
      });
    }
    case ActionTypes.ADD_WIDGET_INTEGRATION_START: {
      const { blockId } = action;
      return newBlockWidgetIntegrationStateByBlockId(state, blockId, {
        errorAddWidgetIntegration: '',
      });
    }
    case ActionTypes.ADD_WIDGET_INTEGRATION_SUCCESS: {
      const { blockId } = action;
      return newBlockWidgetIntegrationStateByBlockId(state, blockId, {
        errorAddWidgetIntegration: '',
      });
    }
    case ActionTypes.ADD_WIDGET_INTEGRATION_FAILED: {
      const { blockId, error } = action;
      return newBlockWidgetIntegrationStateByBlockId(state, blockId, {
        errorAddWidgetIntegration: error,
      });
    }
    case ActionTypes.REMOVE_BLOCK_WIDGET_INTEGRATIONS: {
      const { blockId, widgetIntegrationId } = action;
      const currentWidgetIntegrationByBlockId =
        state.blockWidgetIntegrations[blockId];
      return {
        ...state,
        blockWidgetIntegrations: {
          ...state.blockWidgetIntegrations,
          [blockId]: {
            ...currentWidgetIntegrationByBlockId,
            data: currentWidgetIntegrationByBlockId.data.filter(
              (int) => int.id !== widgetIntegrationId
            ),
          },
        },
      };
    }
    case ActionTypes.GET_ENABLED_WIDGET_INTEGRATION_PROVIDERS_SUCCESS: {
      const { coursePath, enabledWidgetIntegrationProviders } = action;
      return {
        ...state,
        enabledWidgetIntegrationProviders: {
          ...state.enabledWidgetIntegrationProviders,
          [coursePath]: {
            data: enabledWidgetIntegrationProviders,
          },
        },
      };
    }
    default:
      return state;
  }
}
